const React = require("react");
const { useInventorySource } = require("../context/InventorySourceContext");
const { ProductCollectionPage } = require("../components/ProductCollectionPage");
const h = React.createElement;
const DropshippingImportedProducts = () => { const { t } = useInventorySource(); return h(ProductCollectionPage, { imported: true, title: t("h_inventorySource_imported_products", "Imported InventorySource products"), description: t("h_inventorySource_imported_products_desc", "Products already linked to your Elakay shop.") }); };
module.exports = { DropshippingImportedProducts };
